export default class AlwaysRequireResponse {
    constructor(
        public isAlwaysRequired: boolean,
        public errorMessages: string[],
    ) { }
}